import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {
    addCommas,
    addFromColumn,
    convertStartEndDatesForFile,
    createPercentageString,
    parsePercent,
    sortNumber
} from '../shared/functions';
import {setDefaultTableSort, getTableState, filterCaseInsensitive} from '../shared/tableFunctions';
import ReactTable from 'react-table';
import {CSVLink} from 'react-csv';
import FuseTheme from '../global/theme';
import {commonStyles} from '../shared/styles';
import {tableStyles} from '../shared/styles-table';
import FlatButton from 'material-ui/FlatButton';
import ExportIcon from 'material-ui/svg-icons/navigation/arrow-downward';
import ReturnsTableIcon from 'material-ui/svg-icons/navigation/arrow-back';
import SalesTableIcon from 'material-ui/svg-icons/navigation/arrow-forward';
import '../shared/react-table.css';

const styles = {
    headerButton: {
        display: 'inline-block',
        width: 30,
        minWidth: 36,
        height: 30,
        lineHeight: '30px',
        color: FuseTheme.palette.alternateTextColor,
        margin: 0,
    },
    headerButtonIcon: {
        display: 'inline-block',
        position: 'absolute',
        top: 4,
        right: 0,
        color: FuseTheme.palette.alternateTextColor,
        margin: '0 6px 0 8px',
        verticalAlign: 'middle',
        pointerEvents: 'none',
    },
    headerButtonLink: {
        display: 'inline-block',
        color: 'transparent',
        margin: 0,
        overflow: 'hidden',
    },
};

/**
 * Class for displaying Sales Summary Categories Returned and Sold in two tables
 *
 */
class SalesSummaryReportCategoryTables extends Component {
    constructor(props) {
        super(props);
        this.state = {
            returnsSummaryList: [],
            returnsSummaryTableData: [],
            returnsSummaryTableHeaders: [
                {label: 'Category', key: 'category'},
                {label: 'Qty', key: 'qty_returned'},
                {label: 'Percentage', key: 'percent_returned'},
            ],
            message: null,
            salesSummaryList: [],
            salesSummaryTableData: [],
            salesSummaryTableHeaders: [
                {label: 'Category', key: 'category'},
                {label: 'Qty', key: 'qty_sold'},
                {label: 'Percentage', key: 'percent_sold'},
            ],
            summariesComplete: false,
        };
        this.handleExportClick = this.handleExportClick.bind(this);
        this.handleSortOrFilterChange = this.handleSortOrFilterChange.bind(this);
    }

    componentWillMount() {
        this.processData(this.props.listDataReturns, this.props.listDataSales);
    }

    componentWillReceiveProps(nextProps) {
        if (
            nextProps.listDataReturns !== this.props.listDataReturns ||
            nextProps.listDataSales !== this.props.listDataSales
        ) {
            this.setState({
                returnsSummaryList: [],
                returnsSummaryTableData: [],
                salesSummaryList: [],
                salesSummaryTableData: [],
                summariesComplete: false,
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.listDataReturns !== this.props.listDataReturns ||
            prevProps.listDataSales !== this.props.listDataSales
        ) {
            this.processData(this.props.listDataReturns, this.props.listDataSales);
        }
    }

    /* Data Processing ------------------------------ */

    /**
     * Arrange data for use by table
     *
     * @param dataReturns
     * @param dataSales
     */
    processData(dataReturns, dataSales) {

        let returnsSummaryList = [];
        let salesSummaryList = [];

        if (dataReturns) {
            let returnsLength = dataReturns.length;
            let totalQtyReturned = 0;
            for (let r = 0; r < returnsLength; r++) {
                let rResult = dataReturns[r];
                let qtyReturned = (rResult.qty_returned) ? rResult.qty_returned.value : 0;

                const rRow = {
                    category: (rResult.key) ? rResult.key : '(None)',
                    percent_returned: '0%',
                    qty_returned: (qtyReturned) ? qtyReturned : 0
                };
                totalQtyReturned += rRow.qty_returned;
                returnsSummaryList.push(rRow);
            }

            // Cycle through returns to populate percentages
            for (let rp = 0; rp < returnsSummaryList.length; rp++) {
                let rItem = returnsSummaryList[rp];
                let rPercent = ((rItem.qty_returned / totalQtyReturned) * 100);
                // Update the row's percentage value
                rItem.percent_returned = createPercentageString(rPercent);
            }
        }

        if (dataSales) {
            let salesLength = dataSales.length;
            let totalQtySold = 0;
            for (let s = 0; s < salesLength; s++) {
                let sResult = dataSales[s];
                let qtySold = (sResult.qty_sold) ? sResult.qty_sold.value : 0;

                const sRow = {
                    category: (sResult.key) ? sResult.key : '(None)',
                    percent_sold: '0%',
                    qty_sold: (qtySold) ? qtySold : 0
                };
                totalQtySold += sRow.qty_sold;
                salesSummaryList.push(sRow);
            }

            // Cycle through sales to populate percentages
            for (let sp = 0; sp < salesSummaryList.length; sp++) {
                let sItem = salesSummaryList[sp];
                let sPercent = ((sItem.qty_sold / totalQtySold) * 100);
                // Update the row's percentage value
                sItem.percent_sold = createPercentageString(sPercent);
            }
        }

        // Finalize table data
        this.setState({
            returnsSummaryList: returnsSummaryList,
            returnsSummaryTableData: returnsSummaryList,
            salesSummaryList: salesSummaryList,
            salesSummaryTableData: salesSummaryList,
            summariesComplete: true,
        });
        this.props.onSummariesComplete('category', true);
    }

    /* Table Building ------------------------------ */

    /**
     * Update selected table data based on sort
     *
     * @param event
     * @param tableName
     * @param table
     */
    handleSortOrFilterChange(event, tableName, table) {
        const tableData = getTableState(table);
        if (tableData && tableData.length > 0) {
            if (tableName === 'returns') {
                this.setState({
                    returnsSummaryTableData: tableData
                });
            } else if (tableName === 'sales') {
                this.setState({
                    salesSummaryTableData: tableData
                });
            }
        }
    }

    /**
     * Handle event to retrieve current state of table data
     *
     * @param event
     */
    handleExportClick = (event) => {
        // CSVLink handles generation and export of CSV
    };

    /* Table Display ------------------------------ */

    render() {

        const {
            dataIsFiltered,
            endDate,
            startDate,
            system,
        } = this.props;

        const {
            returnsSummaryList,
            returnsSummaryTableData,
            returnsSummaryTableHeaders,
            salesSummaryList,
            salesSummaryTableData,
            salesSummaryTableHeaders,
            summariesComplete,
        } = this.state;

        const dateString = convertStartEndDatesForFile(startDate, endDate);
        const isFilteredString = (dataIsFiltered) ? '-filtered' : '';
        const defaultReturnsSort = setDefaultTableSort({field: 'total_returns', order: 'DESC'});
        const defaultSalesSort = setDefaultTableSort({field: 'total_sold', order: 'DESC'});

        // ReactTable headers and columns for both Tables
        const returnsTableColumns = [
            {
                Header: '',
                columns: [
                    {
                        Header: 'Category',
                        accessor: 'category',
                    },
                    {
                        Header: 'Qty',
                        accessor: 'qty_returned',
                        Cell: row => (
                            <span>{addCommas(row.row.qty_returned)}</span>
                        ),
                        sortMethod: (a, b) => sortNumber(a, b),
                        filterable: false,
                        style: {...tableStyles.right, ...tableStyles.tdMax},
                        Footer: (
                            <span style={tableStyles.footer}>
                                {addCommas(addFromColumn(returnsSummaryTableData, 'qty_returned'))}
                            </span>
                        )
                    },
                    {
                        Header: 'Percentage',
                        accessor: 'percent_returned',
                        sortMethod: (a, b) => sortNumber(parsePercent(a), parsePercent(b)),
                        filterable: false,
                        style: {...tableStyles.right, ...tableStyles.tdMax}
                    },
                ]
            }
        ];

        const salesTableColumns = [
            {
                Header: '',
                columns: [
                    {
                        Header: 'Category',
                        accessor: 'category',
                    },
                    {
                        Header: 'Qty',
                        accessor: 'qty_sold',
                        Cell: row => (
                            <span>{addCommas(row.row.qty_sold)}</span>
                        ),
                        sortMethod: (a, b) => sortNumber(a, b),
                        filterable: false,
                        style: {...tableStyles.right, ...tableStyles.tdMax},
                        Footer: (
                            <span style={tableStyles.footer}>
                                {addCommas(addFromColumn(salesSummaryTableData, 'qty_sold'))}
                            </span>
                        )
                    },
                    {
                        Header: 'Percentage',
                        accessor: 'percent_sold',
                        sortMethod: (a, b) => sortNumber(parsePercent(a), parsePercent(b)),
                        filterable: false,
                        style: {...tableStyles.right, ...tableStyles.tdMax}
                    },
                ]
            }
        ];

        return (
            <div>
                {summariesComplete &&
                <div>
                    <div className="reports-table-container half">

                        {/* Table Header: Sales Summary Categories Sold */}
                        <div className="reports-table-title table-table-header">
                            <div className="btn-report-container table-header-button-container">
                                {/* Export Sales Summary Categories Sold */}
                                <FlatButton
                                    primary
                                    type="button"
                                    label=""
                                    style={styles.headerButton}
                                >
                                    <ExportIcon style={styles.headerButtonIcon}/>
                                    <CSVLink
                                        data={salesSummaryTableData}
                                        headers={salesSummaryTableHeaders}
                                        filename={'Sales-Summary-Categories-Purchased-' + system + '-' + dateString + isFilteredString + '.csv'}
                                        onClick={(e) => this.handleExportClick(e)}
                                        target="_blank"
                                        style={styles.headerButtonLink}
                                    >
                                        Export
                                    </CSVLink>
                                </FlatButton>
                            </div>
                            <h3 className="table-table-header-title">
                                <SalesTableIcon style={commonStyles.summaryIconSmall}/>
                                <span>Categories Purchased</span>
                            </h3>
                        </div>

                        {/* Table: Sales Summary Categories Sold */}
                        <ReactTable
                            key="table-sales-summary-categories-sold"
                            data={salesSummaryList}
                            columns={salesTableColumns}
                            defaultPageSize={5}
                            showPagination={true}
                            defaultSorted={defaultSalesSort}
                            filterable
                            defaultFilterMethod={filterCaseInsensitive}
                            onSortedChange={(e) => this.handleSortOrFilterChange(e, 'sales', this.summaryCategoriesSoldReactTable)}
                            onFilteredChange={(e) => this.handleSortOrFilterChange(e, 'sales', this.summaryCategoriesSoldReactTable)}
                            ref={(r) => this.summaryCategoriesSoldReactTable = r}
                            resizable={false}
                            minRows={1}
                            className="-striped overflow no-print"
                        />
                        <ReactTable
                            key="table-sales-summary-categories-sold-print"
                            data={salesSummaryTableData}
                            columns={salesTableColumns}
                            defaultPageSize={20}
                            showPagination={false}
                            defaultSorted={defaultSalesSort}
                            filterable
                            resizable={false}
                            minRows={1}
                            className="print-only"
                        />
                    </div>

                    <div className="reports-table-container half">

                        {/* Table Header: Sales Summary Categories Returned */}
                        <div className="reports-table-title table-table-header">
                            <div className="btn-report-container table-header-button-container">
                                {/* Export Sales Summary Categories Returned */}
                                <FlatButton
                                    primary
                                    type="button"
                                    label=""
                                    style={styles.headerButton}
                                >
                                    <ExportIcon style={styles.headerButtonIcon}/>
                                    <CSVLink
                                        data={returnsSummaryTableData}
                                        headers={returnsSummaryTableHeaders}
                                        filename={'Sales-Summary-Categories-Returned-' + system + '-' + dateString + isFilteredString + '.csv'}
                                        onClick={(e) => this.handleExportClick(e)}
                                        target="_blank"
                                        style={styles.headerButtonLink}
                                    >
                                        Export
                                    </CSVLink>
                                </FlatButton>
                            </div>
                            <h3 className="table-table-header-title">
                                <ReturnsTableIcon style={commonStyles.summaryIconSmall}/>
                                <span>Categories Returned</span>
                            </h3>
                        </div>

                        {/* Table: Sales Summary Categories Returned */}
                        <ReactTable
                            key="table-sales-summary-categories-returned"
                            data={returnsSummaryList}
                            columns={returnsTableColumns}
                            defaultPageSize={5}
                            showPagination={true}
                            defaultSorted={defaultReturnsSort}
                            filterable
                            defaultFilterMethod={filterCaseInsensitive}
                            onSortedChange={(e) => this.handleSortOrFilterChange(e, 'returns', this.summaryCategoriesReturnedReactTable)}
                            onFilteredChange={(e) => this.handleSortOrFilterChange(e, 'returns', this.summaryCategoriesReturnedReactTable)}
                            ref={(r) => this.summaryCategoriesReturnedReactTable = r}
                            resizable={false}
                            minRows={1}
                            className="-striped overflow no-print"
                        />
                        <ReactTable
                            key="table-sales-summary-categories-returned-print"
                            data={returnsSummaryTableData}
                            columns={returnsTableColumns}
                            defaultPageSize={20}
                            showPagination={false}
                            defaultSorted={defaultReturnsSort}
                            filterable
                            resizable={false}
                            minRows={1}
                            className="print-only"
                        />
                    </div>
                </div>
                }
            </div>
        )
    }
}

SalesSummaryReportCategoryTables.propTypes = {
    addField: PropTypes.bool,
    dataIsFiltered: PropTypes.bool,
    endDate: PropTypes.string,
    listDataReturns: PropTypes.array,
    listDataSales: PropTypes.array,
    onDisplayMessage: PropTypes.func,
    onSummariesComplete: PropTypes.func,
    startDate: PropTypes.string,
    system: PropTypes.string,
};

SalesSummaryReportCategoryTables.defaultProps = {
    addField: true,
    dataIsFiltered: false,
    endDate: null,
    startDate: null,
};

export default SalesSummaryReportCategoryTables;



// WEBPACK FOOTER //
// ./src/Fuse/components/SalesSummaryReportCategoryTables.js